import * as React from "react";
import { makeStyles } from "@mui/styles";

import { ElementsParallax } from "components";
import FeaturesHome from "../home/FeaturesHome";
import BuyHome from "./BuyHome";
import Model from "hooks/Model";

function HomeScreen() {
  const styles = pageStyles();
  React.useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
  }, []);
  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />
      <div className={styles.container}>
        <BuyHome />
        <FeaturesHome />
      </div>
    </>
  );
}

export default HomeScreen;

const pageStyles = makeStyles(() => ({
  container: {
    position: "relative",
    zIndex: 1,
  },
}));
